module.exports = __webpack_public_path__ + "static/News-aa5b7fe11c5f70cdb55ad79f0e88624a.png";